// extracted by mini-css-extract-plugin
export var backupIcon = "_sn-1";
export var image = "_sn-0";